import { Component, Input } from "@angular/core";
import { BaseComponent } from "@base/component/BaseComponent";
import { BaseState } from "@base/entities/BaseEntities";
import { ServiceBagService } from "@base/component/ServiceBag";
import { SlideInOutAnimation } from "../../../animations/slideinout.animation";
import { Utils } from "@core/helpers/Utils";
import { DataGroupInfoHeader } from "@base/classes/BaseClasses";

@Component({
    selector: 'm4u-collapsiblegroup',
    templateUrl: './collapsiblegroup.component.html',
    styleUrls: ['./collapsiblegroup.component.scss'],
    animations: [SlideInOutAnimation]
})
export class CollapsibleGroupComponent extends BaseComponent<BaseState>
{
    @Input() Group: DataGroupInfoHeader;

    constructor(A: ServiceBagService) {
        super(A, "CollapsibleGroupComponent", BaseState);
    }

    get GroupName(): string {
        return Utils.IsEmpty(this.Group.Name) ? this.RC('lblNotAssigned') : this.Group.Name;
    }
}
